export default "__VITE_ASSET__98536924__"